import {
  Button,
  Container,
  Flex,
  Heading,
  Select,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Tfoot,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Back from "../components/Back";
import LoadingPage from "../components/LoadingPage";
import Menu from "../components/Menu";
import { baseService } from "../helpers/baseService";
import { config } from "../helpers/config";
import { setTitle } from "../helpers/title";
import { FaCheck, FaTimes } from "react-icons/fa";
import { VscFilePdf } from "react-icons/vsc";
import { MdArrowDropDown } from "react-icons/md";
import jsPDF from "jspdf";
import "jspdf-autotable";

export default function Participant() {
  const { id } = useParams();
  const [loadingPage, setLoadingPage] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [tableDataFilter, setTableDataFilter] = useState([]);
  const [filter, setFilter] = useState({
    sort: "name",
    asc: true,
  });

  const filterDefaullistFilter = [
    { key: "name", value: "Nama" },
    { key: "gender", value: "Gender" },
    { key: "origin", value: "Asal" },
    { key: "attend", value: "Kehadiran" },
  ];
  const columns = [
    { title: "Name", field: "name" },
    { title: "No. Handphone", field: "phoneNumber" },
    { title: "Gender", field: "gender" },
    { title: "Asal", field: "origin" },
    { title: "Hadir", field: "attend" },
  ];

  useEffect(() => {
    setTitle("Participant List | Admin");
  }, []);

  useEffect(() => {
    setLoadingPage(true);
    baseService.post(
      config.services.event.getEventParticipantById + id,
      filter,
      (res) => {
        setTableData(res.data.participant);
        setTableDataFilter(res.data.participant);
      },
      (err) => console.log(err)
    );
    setLoadingPage(false);
    // eslint-disable-next-line
  }, [filter]);

  function exportPDF() {
    const doc = new jsPDF();

    doc.text(`${tableData[0]?.eventDetail?.eventName} Participant`, 13, 10);
    doc.autoTable({
      theme: "grid",
      columns: columns.map((col) => ({ ...col, dataKey: col.field })),
      body: tableDataFilter.map((data) => ({
        ...data,
        attend: data.attend ? "Hadir" : "Tidak Hadir",
      })),
    });
    doc.autoTable({
      html: "#table-footer",
    });
    doc.save(`${tableData[0]?.eventDetail?.eventName} Participant.pdf`);
  }

  return (
    <div>
      <div className="container" />
      <Back title="List Participant" />
      <div className="content">
        {loadingPage && <LoadingPage />}
        <Flex justifyContent="space-between" alignItems="flex-end" mb={3}>
          <Container ml={0} p={0}>
            <Heading size="md" mb={3}>
              Event - {tableData[0]?.eventDetail?.eventName}
            </Heading>
            <Flex gap={2} pr={2}>
              {/* Urutan Asc or Desc */}
              <div>
                <Text fontSize="xs">Sort</Text>
                <Select
                  icon={<MdArrowDropDown />}
                  placeholder="Urutkan"
                  size="sm"
                  defaultValue={filter.asc ? "asc" : "desc" || ""}
                  onChange={(e) => {
                    if (!e.target.value) return;
                    setFilter({
                      ...filter,
                      asc: e.target.value === "asc" ? true : false,
                    });
                  }}
                >
                  <option value="asc">A-Z</option>
                  <option value="desc">Z-A</option>
                </Select>
              </div>

              {/* Filter */}
              <div>
                <Text fontSize="xs">Filter</Text>
                <Select
                  icon={<MdArrowDropDown />}
                  placeholder="Filter"
                  size="sm"
                  defaultValue={filter.sort || ""}
                  onChange={(e) => {
                    if (!e.target.value) return;
                    setFilter({ ...filter, sort: e.target.value });
                  }}
                >
                  {filterDefaullistFilter.map((filter) => {
                    return (
                      <option key={filter.key} value={filter.key}>
                        {filter.value}
                      </option>
                    );
                  })}
                </Select>
              </div>
              {/* based on origin */}
              {(filter.sort === "origin" || filter.sort === "attend") && (
                <div>
                  <Text fontSize="xs">Asal</Text>
                  <Select
                    icon={<MdArrowDropDown />}
                    placeholder="Pilih Asal"
                    size="sm"
                    onChange={(e) => {
                      if (!e.target.value) {
                        return setTableDataFilter(tableData);
                      }
                      setTableDataFilter(
                        tableData.filter(
                          (data) => data.origin === e.target.value
                        )
                      );
                    }}
                  >
                    {tableData[0].eventDetail?.origin.map((origin) => {
                      return (
                        <option key={origin} value={origin}>
                          {origin}
                        </option>
                      );
                    })}
                  </Select>
                </div>
              )}
            </Flex>
          </Container>

          {tableData[0]?.eventDetail?.eventName && (
            <Button
              alignItems="center"
              leftIcon={<VscFilePdf />}
              colorScheme="blue"
              onClick={exportPDF}
            >
              <Text fontSize="sm">Export</Text>
            </Button>
          )}
        </Flex>

        <TableContainer className="table">
          <Table size="sm" variant="striped" colorScheme="blue">
            <Thead backgroundColor="blue.400">
              <Tr>
                {columns.map((thead) => {
                  return <Th key={thead.field}>{thead.title}</Th>;
                })}
              </Tr>
            </Thead>
            <Tbody>
              {tableDataFilter.map((data) => {
                return (
                  <Tr key={data._id}>
                    <Td>{data.name}</Td>
                    <Td>{data.phoneNumber}</Td>
                    <Td>{data.gender}</Td>
                    <Td>{data.origin || "-"}</Td>
                    <Td>{data.attend ? <FaCheck /> : <FaTimes />}</Td>
                  </Tr>
                );
              })}
            </Tbody>
            <Tfoot id="table-footer">
              <Tr>
                <Th colSpan={2} textAlign="start !important">
                  Total participant: {tableDataFilter.length}
                </Th>
                <Th></Th>
                <Th colSpan={2} textAlign="end !important">
                  Total Hadir:{" "}
                  {
                    tableDataFilter.filter((data) => data.attend === true)
                      .length
                  }
                </Th>
              </Tr>
            </Tfoot>
          </Table>
        </TableContainer>
      </div>
      <Menu />
    </div>
  );
}
